import React, { useState } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  FormControl,
  Select,
  Text
} from '@primer/react';
import { Dialog } from "@primer/react/drafts";
import { useForm } from 'react-hook-form';
import { useCommonContext } from '../../../../contexts/common';
import { NotifyHelper } from '../../../../helpers/toast';
import { ketQuaThiApi } from '../../../../api/ketQuaThiApi';

interface DanhGiaKetQuaModalProps {
  is_show_model: boolean;
  ex_thisinh_ids: number[];
  ex_trangthai_hocsinh: Array<{
    id: number;
    ten_trangthai: string;
  }>;
  onCancel: () => void;
  onSuccess: () => void;
}

const DanhGiaKetQuaModal: React.FC<DanhGiaKetQuaModalProps> = ({
  is_show_model,
  ex_thisinh_ids,
  ex_trangthai_hocsinh,
  onCancel,
  onSuccess
}) => {
  const { translate } = useCommonContext();
  const [isSaving, setIsSaving] = useState(false);
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({
    defaultValues: {
      ex_thisinh_ids: ex_thisinh_ids || [],
      ex_trangthai_thisinh_id: 0
    }
  });

  const onSubmit = async (data: any) => {
    setIsSaving(true);
    try {
      const res = await ketQuaThiApi.UpdateDanhGiaKetQuaThiAsync({
        ex_thisinh_ids: ex_thisinh_ids,
        ex_trangthai_thisinh_id: data.ex_trangthai_thisinh_id
      });
      
      if (res.is_success) {
        NotifyHelper.Success(translate('Đánh giá kết quả thi thành công'));
        onSuccess();
      } else {
        NotifyHelper.Error(res.message || translate('Error.Generic'));
      }
    } catch (error) {
      NotifyHelper.Error(translate('Error.Generic'));
    }
    setIsSaving(false);
    onCancel();
  };

  return (
    <Dialog 
      //isOpen={is_show_model}
      onClose={onCancel}
      width="medium"
      title={translate('Đánh giá kết quả thi thi sinh')}
    >
      <Box as="form" onSubmit={handleSubmit(onSubmit)} p={0}>
        <Dialog.Body sx={{p:0}}>
          <FormControl id="trangthai" required >
            <FormControl.Label>{translate('Kết quả đánh giá')}</FormControl.Label>
            <Select
              {...register('ex_trangthai_thisinh_id', { 
                required: translate('Vui lòng chọn kết quả đánh giá'),
                min: { value: 1, message: translate('Vui lòng chọn kết quả đánh giá') }
              })}
              onChange={(e) => {
                setValue('ex_trangthai_thisinh_id', parseInt(e.target.value));
              }}
              block
            >
              <option value={0}>{translate('Chọn kết quả đánh giá')}</option>
              {ex_trangthai_hocsinh.map(item => (
                <option key={item.id} value={item.id}>
                  {item.ten_trangthai}
                </option>
              ))}
            </Select>
            {/* {errors.ex_trangthai_thisinh_id && (
              <FormControl.Error>
                {errors.ex_trangthai_thisinh_id.message as string}
              </FormControl.Error>
            )} */}
          </FormControl>
        </Dialog.Body>

        <Dialog.Footer>
          <ButtonGroup>
            <Button onClick={onCancel}>
              {translate('Base.Label.Cancel')}
            </Button>
            <Button 
              variant="primary" 
              type="submit"
              disabled={isSaving}
            >
              {translate('Đánh giá kết quả')}
            </Button>
          </ButtonGroup>
        </Dialog.Footer>
      </Box>
    </Dialog>
  );
};

export default DanhGiaKetQuaModal;